var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('alert-alert'),_c('div',{staticClass:"content-container-for-sticky-footer"},[_c('Header'),_c('router-view',{key:_vm.$route.fullPath})],1),_c('Footer'),_c('AgreeToTermsPopup')],1)}
var staticRenderFns = []

export { render, staticRenderFns }